const ERROR_PREFIX = '[qubo]';
export function createError(message) {
    throw new Error(`${ERROR_PREFIX} ${message}`);
}
export function createTypeError(message) {
    throw new TypeError(`${ERROR_PREFIX} ${message}`);
}
